import { render } from "./CourseSuggestForm.vue?vue&type=template&id=23f33c00&scoped=true"
import script from "./CourseSuggestForm.vue?vue&type=script&lang=js"
export * from "./CourseSuggestForm.vue?vue&type=script&lang=js"

import "./CourseSuggestForm.vue?vue&type=style&index=0&id=23f33c00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f33c00"]])

export default __exports__